import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Tooltip,
  Paper,
  Button,
  Box,
  Stack,
  Typography,
  Divider,
  Tabs,
  Tab,
  Badge,
  MenuItem,
  FormControl,
  FormControlLabel,
  Switch,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  FolderCopy,
  FolderOff,
  LocalShipping,
  MoveUp,
  WhereToVote,
  WorkHistory,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Download,
  Eye,
  EyeSlash,
  FileArrowUpFill,
} from "react-bootstrap-icons";

import API from "../../data/api";
// import GlobalFilter from '../global-filter/GlobalFilter';
import CustomTablePagination from "../custom/CustomTablePagination";
import { isAuthorizedRole } from "../../utils/authUtil";
import palette from "../../theme/palette";
import { isNotNullValue, isNullValue } from "../../utils/formUtil";
import { FormItemlGrid } from "../ui/FormItemlGrid";
import CustomModal from "../custom/CustomModal";
import FileDragzone from "../ui/FileDragzone";
import CustomPdfViewer from "../custom/CustomPdfViewer";
import {
  filePreviewStyle,
  MAX_FILE_SIZE_MB,
  nestedTableStyle,
} from "../../utils/constants";
import { downloadFile } from "../../utils/fileUtils";
import { CustomSelect } from "../custom/CustomSelect";
import { OrderNominationSummary } from "./modals/OrderNominationSummary";
import { OrderAllocationSummary } from "./modals/OrderAllocationSummary";
import { fNumber } from "../../utils/formatNumber";
import AssignEnrouteTruck from "./modals/AssignEnrouteTruck";
import { OrderCollectionConfirmation } from "./modals/OrderCollectionConfirmation";
import { DepotDeliveryConfirmation } from "./modals/DepotDeliveryConfirmation";

const initDocumentForm = {
  value: "",
  required: true,
  error: false,
  errorMessage: "Please specify a document type",
};

const documentTypes = [
  { key: "COMMERICAL INVOICE", value: "Commercial Invoice" },
  { key: "NOMINATION", value: "Nomination" },
  { key: "RELEASE FORM", value: "Release Form" },
  { key: "TRANSIT CLEARANCE", value: "Transit Clearance" },
  { key: "SARS CUSTOMS", value: "SARS Customs" },
  { key: "BURS DOCUMENTS", value: "BURS Documents" },
];

const customsDocumentChecklist = [
  {
    key: "commercial_invoice",
    label: "Commercial Invoice",
    uploadType: "COMMERICAL INVOICE",
  },
  {
    key: "transit_clearance",
    label: "Transit Clearance",
    uploadType: "TRANSIT CLEARANCE",
  },
  {
    key: "sars_clearance",
    label: "SARS Customs",
    uploadType: "SARS CUSTOMS",
  },
  {
    key: "nomination",
    label: "Nomination",
    uploadType: "NOMINATION",
  },
  {
    key: "release_form",
    label: "Release Form",
    uploadType: "RELEASE FORM",
  },
  {
    key: "burs_documents",
    label: "BURS Crossing",
    uploadType: "BURS DOCUMENTS",
  },
];

export default class AllocatedOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allocatedOrders: [],
      page: 1,
      records: 15,
      totalRecords: 1,
      totalPages: null,
      recordsList: [5, 10, 15, 20],
      expandedRow: null,
      selectedOrder: null,
      processedOrder: {
        openModal: false,
        orderItem: null,
        isTaxInvoice: false,
      },
      fileObjects: [],
      filePreviewUrl: null,
      isFilePreview: false,
      modalStyle: {},
      upload: { ...initDocumentForm },
      selectedSubDocument: null,
      openSubDocumentModal: false,
      viewAllocationSummary: false,
      viewNominationSummary: false,
      unassignedClientSubOrders: [],
      openTruckAssignment: false,
      assignedClientSubOrders: [],
      viewTruckAssignment: false,
      selectedSubOrder: null,
      viewConfirmCollection: false,
      selectedTruckAssignment: null,
      viewConfirmDelivery: false,
      skipReleaseFormUpload: false,
      isReleaseForm: false,
      customsTab: 0,
      outstandingSuborders: [],
      outstandingCount: 0,
      openOutstandingSummary: false,
      openOutstandingLogistics: false,
      selectedOutstandingSuborder: null,
    };
  }

  componentDidMount() {
    this.loadRefreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.filterString !== this.props.filterString) {
      this.loadRefreshData();
    }
  }

  loadRefreshData = async (finalQuery = "") => {
    this.getAllocatedOrders(this.props.filterString);
    this.getOutstandingNotifications();
  };

  getAllocatedOrders = async (finalQuery = "") => {
    const { records, page } = this.state;
    let conTemp = `inventory/backoffice/allocated_suborders?records=${records}&page=${page}`;

    if (finalQuery) {
      conTemp += finalQuery;
    }

    try {
      const res = await API.get(conTemp);
      if (res.status === 200) {
        const suborders = res.data.suborders;
        this.setState({
          allocatedOrders: suborders,
          totalPages: res.data.total_pages, //Math.min(res.data.total_pages, Math.ceil(suborders?.length/this.state.records)),
          totalRecords: res.data.total_suborders,
        });
      } else {
        console.error("Error fetching allocated orders");
      }
    } catch (error) {
      console.error("Error fetching allocated orders:", error);
    }
  };

  getOutstandingNotifications = async () => {
    const { records, page } = this.state;
    const endPoint = `notifications/suborders?records=${records}&page=${page}`;
    try {
      const res = await API.get(endPoint);
      if (res.status === 200) {
        this.setState({
          outstandingSuborders: res.data?.suborders || [],
          outstandingCount:
            res.data?.count ?? res.data?.suborders?.length ?? 0,
        });
      } else {
        console.error("Error fetching outstanding documents");
      }
    } catch (error) {
      console.error("Error fetching outstanding documents:", error);
    }
  };

  getSubOrderDocuments = async (subOrder_id) => {
    if (!subOrder_id) {
      return;
    }

    try {
      const response = await API.get(
        `inventorylogistics/get_logistics_forms?suborder_id=${subOrder_id}`,
      );
      if (response.status === 200) {
        this.setState({ subOrderDocuments: response.data?.documents });
      } else {
        console.error("Error fetching documents: ", response.status);
      }
    } catch (error) {
      console.error("Error fetching documents: ", error);
    }
  };

  getUnassignedClientSubOrders = async (subOrder) => {
    try {
      const endPoint =
        `inventory/logistics/unassigned_suborders?volume_max=${subOrder?.available_volume}`.concat(
          `&product_id=${subOrder?.product_id}`,
        );
      const response = await API.get(endPoint);
      if (response.status === 200) {
        this.setState({ unassignedClientSubOrders: response.data?.suborders });
      } else {
        console.error(
          "Error fetching unassigned client subOrders:",
          response.status,
        );
      }
    } catch (error) {
      console.error("Error fetching unassigned client subOrders: ", error);
    }
  };

  getAssignedClientSubOrders = async (suborderId) => {
    try {
      const endPoint = `inventory/logistics/assigned_suborders?supplier_suborder_id=${suborderId}`;
      const response = await API.get(endPoint);
      if (response.status === 200) {
        const indexedOrders = response.data?.suborders.map((o, index) => {
          return { ...o, index: index };
        });
        this.setState({ assignedClientSubOrders: indexedOrders });
      } else {
        console.error(
          "Error fetching unassigned client subOrders:",
          response.status,
        );
      }
    } catch (error) {
      console.error("Error fetching unassigned client subOrders: ", error);
    }
  };

  handleDocumentSubmit = async () => {
    const { fileObjects, selectedOrder, upload, skipReleaseFormUpload } =
      this.state;

    if (
      !skipReleaseFormUpload &&
      (fileObjects.length === 0 ||
        fileObjects[0] === null ||
        isNullValue(selectedOrder?.suborder_id) ||
        isNullValue(upload?.value))
    ) {
      this.props?.showSnackbar({
        message:
          "Please ensure you have specified document type, and attached a valid document.",
        type: "error",
      });
      return;
    }

    let endPoint =
      `inventory/logistics/upload_logistics_form?suborder_id=${selectedOrder?.suborder_id}`
        .concat(`&form_type=${upload?.value}`)
        .concat(`&release_form_uploaded=${skipReleaseFormUpload}`);

    const formData = new FormData();
    formData.append("file", fileObjects[0]);

    this.setState({ submitted: true });
    try {
      const res = await API.post(`${endPoint}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200 || res.status === 201) {
        this.handleDocumentUploadModal(null, false);
        this.props.setUpdateStats(true);
        this.getSubOrderDocuments();
        this.loadRefreshData();
      } else {
        console.log("Error:", res.data);
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    }
    this.setState({ submitted: false });
  };

  handleGenerateReport = async (suborder_id) => {
    try {
      const generateSuborderReport = await API.get(
        `inventory/logistics/generate_suborder_report/${suborder_id}`,
      );
      if (generateSuborderReport.status === 200) {
        console.log("Report successfully generated");
      } else {
        console.error(
          "Error generating suborder report:",
          generateSuborderReport.status,
        );
      }
    } catch (error) {
      console.error("Error reendering QR code:", error);
    }
  };

  setValidatedNomination = (_nomination) => {
    this.setState({
      nomination: { ..._nomination },
    });
  };

  nextPage = (action) => {
    const { totalPages } = this.state;
    this.setState(
      (prevState) => {
        let currentPage = prevState.page;

        if (action === "next") {
          currentPage = Math.min(currentPage + 1, totalPages);
        } else {
          currentPage = Math.max(currentPage - 1, 1);
        }

        return { page: currentPage };
      },
      () => {
        this.getAllocatedOrders(this.props.filterString);
        this.getOutstandingNotifications();
      },
    ); //this.getAllocatedOrders);
  };

  setSubOrder = async (subOrder) => {
    if (this.state.selectedOrder?.suborder_id === subOrder?.suborder_id) {
      this.setState({ selectedOrder: null });
    } else {
      this.setState({ selectedOrder: subOrder });
      this.getSubOrderDocuments(subOrder?.suborder_id);
    }
  };

  handleFileObjects = (files) => {
    const file = files.length > 0 ? files[0] : null;

    this.setState({
      fileObjects: files,
      filePreviewUrl: file ? URL.createObjectURL(file) : null,
    });
  };

  handleDocumentPreview = () => {
    const { fileObjects } = this.state;

    const typeError = isNullValue(this.state.upload?.value);
    this.setState({
      upload: {
        ...this.state.upload,
        error: typeError,
      },
    });

    if (fileObjects.length === 0 || fileObjects[0] === null || typeError) {
      this.props?.showSnackbar({
        message:
          "Please ensure you have specified document type, and attached a valid document.",
        type: "error",
      });
      return;
    }

    this.setState({
      modalStyle: { ...filePreviewStyle },
      isFilePreview: true,
    });
  };

  // handleChangeRowsPerPage = (event) => {
  //   this.setState(
  //     () => {
  //       return { records: parseInt(event.target.value, 10), page: 1 };
  //     },
  //     () => {
  //       this.getDeliveredOrders(this.props.filterString);
  //     },
  //   );
  // };

  handleChangeRowsPerPage = (event) => {
    this.setState({ records: parseInt(event.target.value, 10), page: 1 }, () =>
      {
        this.getAllocatedOrders(this.props.filterString);
        this.getOutstandingNotifications();
      },
    );
  };

  handleDocumentUploadModal = (subOrder, isOpen) => {
    this.setState({
      upload: { ...initDocumentForm },
      selectedOrder: subOrder,
      openDocumentModal: isOpen,
      fileObjects: [],
      filePreviewUrl: null,
      isFilePreview: false,
      modalStyle: {},
      viewAllocationSummary: false,
      viewNominationSummary: false,
    });
  };

  handleCustomsDocumentUpload = (subOrder, docType) => {
    this.setState({
      upload: { ...initDocumentForm, value: docType || "" },
      selectedOrder: subOrder,
      openDocumentModal: true,
      fileObjects: [],
      filePreviewUrl: null,
      isFilePreview: false,
      modalStyle: {},
      viewAllocationSummary: false,
      viewNominationSummary: false,
      skipReleaseFormUpload: false,
      isReleaseForm: docType === "RELEASE FORM",
    });
  };

  handleOutstandingSummary = (subOrder = null) => {
    this.setState({
      selectedOutstandingSuborder: subOrder,
      openOutstandingSummary: isNotNullValue(subOrder),
    });
  };

  handleOutstandingLogistics = (subOrder = null) => {
    this.setState({
      selectedOutstandingSuborder: subOrder,
      openOutstandingLogistics: isNotNullValue(subOrder),
    });
  };

  handleViewSubOrderDocument = async (subDocument) => {
    this.setState({
      selectedSubDocument: subDocument,
      openSubDocumentModal: isNotNullValue(subDocument),
    });
  };
  handleViewAllocationSummary = (subOrder = null) => {
    const _order =
      isNullValue(subOrder) && this.state.viewTruckAssignment
        ? this.state.selectedOrder
        : subOrder;
    this.setState({
      viewAllocationSummary: isNotNullValue(subOrder),
      selectedOrder: _order,
    });
  };

  handleViewNominationSummary = (subOrder = null) => {
    this.setState({
      viewNominationSummary: isNotNullValue(subOrder),
      selectedOrder: subOrder,
    });
  };

  handleAssignEnrouteTruck = (subOrder = null, reloadView = false) => {
    let _order = subOrder;
    if (reloadView) {
      if (isNullValue(subOrder) && this.state.viewTruckAssignment) {
        console.log(this.state.selectedOrder, this.state.viewTruckAssignment);
        _order = this.state.selectedOrder;
        this.getAssignedClientSubOrders(_order?.suborder_id);
      }

      this.loadRefreshData();
    }

    this.setState({
      openTruckAssignment: isNotNullValue(subOrder),
      selectedOrder: _order,
    });

    if (isNotNullValue(subOrder)) {
      this.getUnassignedClientSubOrders(subOrder);
    }
  };

  handleViewTruckAssignments = (subOrder = null) => {
    if (this.state.viewTruckAssignment) {
      this.setState({
        selectedOrder: null,
        viewTruckAssignment: false,
      });
    } else {
      this.setState({
        viewTruckAssignment: isNotNullValue(subOrder),
        selectedOrder: subOrder,
      });

      if (isNotNullValue(subOrder)) {
        this.getAssignedClientSubOrders(subOrder.suborder_id);
      }
    }
  };

  handleConfirmCollection = (subOrder = null) => {
    this.setState({
      viewConfirmCollection: isNotNullValue(subOrder),
      selectedOrder: subOrder,
    });
  };

  handleConfirmDepotDelivery = (truckAssignment = null) => {
    this.setState({
      viewConfirmDelivery: isNotNullValue(truckAssignment),
      selectedTruckAssignment: truckAssignment,
    });
  };

  notifyError = (message) => {
    this.props.showSnackbar({
      message: message,
      type: "error",
    });
  };

  isUploadedStatus = (value) => {
    if (value === true) {
      return true;
    }
    if (typeof value === "number") {
      return value > 0;
    }
    const normalized = String(value || "").trim().toLowerCase();
    return (
      normalized === "uploaded" ||
      normalized === "true" ||
      normalized === "yes" ||
      normalized === "complete" ||
      normalized === "completed"
    );
  };

  normalizeDocumentType = (value) => {
    const upper = String(value || "").trim().toUpperCase();
    if (!upper) {
      return "";
    }
    if (upper.includes("BURS")) {
      return "BURS DOCUMENTS";
    }
    if (upper.includes("SARS")) {
      return "SARS CUSTOMS";
    }
    if (upper.includes("TRANSIT")) {
      return "TRANSIT CLEARANCE";
    }
    if (upper.includes("COMMERCIAL")) {
      return "COMMERICAL INVOICE";
    }
    if (upper.includes("RELEASE")) {
      return "RELEASE FORM";
    }
    if (upper.includes("NOMINATION")) {
      return "NOMINATION";
    }
    return upper;
  };

  getOutstandingDocuments = (subOrder) => {
    return customsDocumentChecklist.filter(
      (doc) => !this.isUploadedStatus(subOrder?.[doc.key]),
    );
  };

  areAllCustomsDocumentsUploaded = (subOrder) => {
    const uploadedCount = customsDocumentChecklist.reduce((count, doc) => {
      return count + (this.isUploadedStatus(subOrder?.[doc.key]) ? 1 : 0);
    }, 0);

    return uploadedCount === customsDocumentChecklist.length;
  };

  getUploadedCountFromDocuments = (documents = []) => {
    const uploadedTypes = new Set(
      (documents || [])
        .map((doc) => this.normalizeDocumentType(doc?.document_type))
        .filter((type) => isNotNullValue(type)),
    );

    return customsDocumentChecklist.filter((doc) =>
      uploadedTypes.has(doc.uploadType),
    ).length;
  };

  getUploadedCountForRow = (row) => {
    if (Array.isArray(row?.documents) && row.documents.length > 0) {
      return this.getUploadedCountFromDocuments(row.documents);
    }

    if (this.state.selectedOrder?.suborder_id === row?.suborder_id) {
      return this.getUploadedCountFromDocuments(this.state.subOrderDocuments);
    }

    return customsDocumentChecklist.reduce((count, doc) => {
      return count + (this.isUploadedStatus(row?.[doc.key]) ? 1 : 0);
    }, 0);
  };

  getOutstandingDocumentCount = (row) => {
    if (typeof row?.outstanding_documents === "number") {
      return row.outstanding_documents;
    }

    const uploadedCount = this.getUploadedCountForRow(row);
    return Math.max(customsDocumentChecklist.length - uploadedCount, 0);
  };

  getRibbonColor = (outstandingCount) => {
    if (outstandingCount <= 0) {
      return palette.success.main;
    }
    if (outstandingCount >= customsDocumentChecklist.length) {
      return palette.error.main;
    }

    const ratio =
      outstandingCount / Math.max(customsDocumentChecklist.length, 1);

    if (ratio >= 0.75) {
      return palette.error.main;
    }
    if (ratio >= 0.5) {
      return palette.warning.main;
    }

    return palette.info.main;
  };

  formatDateTime = (value) => {
    return value ? moment(value).format("YYYY/MM/DD - HH:mm:ss") : "-";
  };

  getMissingCountFromUploads = (uploadedDocuments = []) => {
    const uploadedTypes = new Set(
      (uploadedDocuments || [])
        .map((doc) => this.normalizeDocumentType(doc?.document_type))
        .filter((type) => isNotNullValue(type)),
    );

    return customsDocumentChecklist.filter(
      (doc) => doc.uploadType && !uploadedTypes.has(doc.uploadType),
    ).length;
  };

  render() {
    const {
      allocatedOrders,
      filePreviewUrl,
      isFilePreview,
      fileObjects,
      modalStyle,
      openDocumentModal,
      selectedSubDocument,
    } = this.state;
    const isCustoms = isAuthorizedRole(["CUSTOMS-L1"]);
    const outstandingSuborders = this.state.outstandingSuborders || [];
    const outstandingCount =
      this.state.outstandingCount || outstandingSuborders.length;
    const selectedOutstandingSuborder = this.state.selectedOutstandingSuborder;
    const selectedMissingCount = this.getMissingCountFromUploads(
      this.state.subOrderDocuments,
    );

    return (
      <Paper>
        {/* <GlobalFilter sx={{ my: 1 }} onFilterChange={this.handleFilterChange} /> */}

        {isCustoms && (
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={this.state.customsTab}
              onChange={(_, newValue) =>
                this.setState({ customsTab: newValue, selectedOrder: null })
              }
            >
              <Tab label="Allocated Suborders" />
              <Tab
                label={
                  <Badge
                    badgeContent={outstandingCount}
                    color="error"
                  >
                    Outstanding Documents
                  </Badge>
                }
              />
            </Tabs>
          </Box>
        )}

        {(!isCustoms || this.state.customsTab === 0) && (
          <TableContainer
            sx={{
              mt: 2,
              width: "100%",
              overflowX: { xs: "scroll", sm: "auto" },
            }}
          >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {isCustoms && (
                  <TableCell sx={{ width: 8, p: 0 }} />
                )}
                <TableCell>Order Item ID</TableCell>
                <TableCell align="right">Supplier Name</TableCell>
                <TableCell align="right">Product</TableCell>
                <TableCell align="right">Volume</TableCell>
                <TableCell align="right">Delivery Date</TableCell>
                <TableCell align="right">Delivery Location</TableCell>
                <TableCell align="right">Status</TableCell>
                {!isAuthorizedRole([["CUSTOMS-L1", "DEMO"]]) && (
                  <TableCell align="right">Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {allocatedOrders.map((row) => (
                <>
                  {(() => {
                    const outstandingCount = this.getOutstandingDocumentCount(
                      row,
                    );
                    const ribbonColor = this.getRibbonColor(outstandingCount);
                    return (
                  <TableRow
                    key={"table-row-" + row.suborder_id}
                    selected={
                      this.state.selectedOrder?.suborder_id === row.suborder_id
                    }
                    // onClick={() => this.setState({selectedOrder: row})}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "&:hover": { backgroundColor: "rgba(39,226,245,0.27)" },
                    }}
                  >
                    {isCustoms && (
                      <TableCell
                        sx={{
                          width: 8,
                          p: 0,
                          backgroundColor: ribbonColor,
                        }}
                      />
                    )}
                    <TableCell component="th" scope="row">
                      {row.suborder_id}
                    </TableCell>
                    <TableCell align="right">{row.supplier_name}</TableCell>
                    <TableCell align="right">{row.fuel_type}</TableCell>
                    <TableCell align="right">{fNumber(row.volume)}</TableCell>
                    <TableCell align="right">
                      {moment(row.delivery_scheduled_datetime).format(
                        "YYYY/MM/DD - HH:mm:ss",
                      )}
                    </TableCell>
                    <TableCell align="right">{row.delivery_location}</TableCell>
                    <TableCell align="right">{row.status}</TableCell>
                    {isAuthorizedRole(["CUSTOMS-L1"]) && (
                      <TableCell align="right">
                        {row.manual_volume_entry_required && (
                          <Tooltip title="Confirm Collection">
                            <IconButton
                              onClick={() => this.handleConfirmCollection(row)}
                            >
                              <WhereToVote color="success" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {row?.is_nominated && (
                          <>
                            <Tooltip title="Nomination Summary">
                              <IconButton
                                onClick={() =>
                                  this.handleViewAllocationSummary(row)
                                }
                              >
                                <WorkHistory color={palette.warning.main} />
                              </IconButton>
                            </Tooltip>
                            {this.state.selectedOrder?.suborder_id ===
                            row.suborder_id ? (
                              <Tooltip title="Hide Documents">
                                <IconButton
                                  onClick={() => this.setSubOrder(row)}
                                >
                                  <Badge
                                    badgeContent={this.getOutstandingDocumentCount(
                                      row,
                                    )}
                                    color="error"
                                    invisible={
                                      this.getOutstandingDocumentCount(row) ===
                                      0
                                    }
                                  >
                                    <FolderOff color={palette.info.main} />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Vew Documents">
                                <IconButton
                                  onClick={() => this.setSubOrder(row)}
                                >
                                  <Badge
                                    badgeContent={this.getOutstandingDocumentCount(
                                      row,
                                    )}
                                    color="error"
                                    invisible={
                                      this.getOutstandingDocumentCount(row) ===
                                      0
                                    }
                                  >
                                    <FolderCopy color={palette.info.main} />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                            )}
                            <Tooltip title="Upload Document">
                              <IconButton
                                onClick={() =>
                                  this.handleDocumentUploadModal(row, true)
                                }
                              >
                                <FileArrowUpFill color={palette.success.main} />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </TableCell>
                    )}
                    {row?.is_nominated &&
                      isAuthorizedRole(["LOGISTICS-C2"]) && (
                        <TableCell align="right">
                          <>
                            {row?.available_volume < row?.volume &&
                              (this.state.viewTruckAssignment &&
                              this.state.selectedOrder?.suborder_id ===
                                row?.suborder_id ? (
                                <Tooltip title="Hide Truck Assignments">
                                  <IconButton
                                    onClick={() =>
                                      this.handleViewTruckAssignments(null)
                                    }
                                  >
                                    <EyeSlash color={palette.info.main} />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip title="View Truck Assignments">
                                  <IconButton
                                    onClick={() =>
                                      this.handleViewTruckAssignments(row)
                                    }
                                  >
                                    <Eye color={palette.info.main} />
                                  </IconButton>
                                </Tooltip>
                              ))}
                            <Tooltip title="Nomination Summary">
                              <IconButton
                                onClick={() =>
                                  this.handleViewAllocationSummary(row)
                                }
                              >
                                <WorkHistory color={palette.warning.main} />
                              </IconButton>
                            </Tooltip>
                            {row?.available_volume > 0 && (
                              <Tooltip title="Assign Enroute Truck">
                                <IconButton
                                  onClick={() =>
                                    this.handleAssignEnrouteTruck(row)
                                  }
                                >
                                  <MoveUp color="success" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </>
                        </TableCell>
                      )}
                  </TableRow>
                    );
                  })()}
                  {this.state.selectedOrder?.suborder_id === row.suborder_id &&
                    row?.is_nominated &&
                    isAuthorizedRole(["CUSTOMS-L1"]) && (
                      <TableRow
                        selected={
                          this.state.selectedOrder?.suborder_id ===
                          row.suborder_id
                        }
                      >
                        <TableCell colSpan={isCustoms ? 10 : 9}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography variant="subtitle2">
                              Missing documents: {selectedMissingCount}
                            </Typography>
                          </Box>
                          <TableContainer
                            sx={{
                              mt: 2,
                              width: "100%",
                              overflowX: { xs: "scroll", sm: "auto" },
                            }}
                          >
                            <Table size="small" aria-label="suborders">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Document</TableCell>
                                  <TableCell>Date Time</TableCell>
                                  <TableCell>Type</TableCell>
                                  <TableCell align="right">Actions</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.subOrderDocuments?.map((docRow) => (
                                  <TableRow
                                    key={"doc-row-" + docRow?.document_id}
                                    sx={{ ...nestedTableStyle }}
                                    selected={
                                      this.state.currentSubOrder ===
                                      docRow.suborder_id
                                    }
                                  >
                                    <TableCell>
                                      {docRow.document_file_name}
                                    </TableCell>
                                    <TableCell>
                                      {moment(
                                        docRow?.uploaded_at || null,
                                      ).format("YYYY/MM/DD - HH:mm:ss")}
                                    </TableCell>
                                    <TableCell>
                                      {docRow?.document_type}
                                    </TableCell>
                                    <TableCell align="right">
                                      <IconButton
                                        onClick={() =>
                                          this.handleViewSubOrderDocument(
                                            docRow,
                                          )
                                        }
                                      >
                                        <Eye color={palette.info.main} />
                                      </IconButton>
                                      <IconButton
                                        onClick={() =>
                                          downloadFile(
                                            docRow?.document_url,
                                            docRow?.document_file_name,
                                          )
                                        }
                                      >
                                        <Download color={palette.info.main} />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TableCell>
                      </TableRow>
                    )}
                  {this.state.selectedOrder?.suborder_id === row.suborder_id &&
                    row?.is_nominated &&
                    row.available_volume < row.volume &&
                    isAuthorizedRole(["LOGISTICS-C2"]) && (
                      <TableRow
                        selected={
                          this.state.selectedOrder?.suborder_id ===
                          row.suborder_id
                        }
                      >
                        <TableCell colSpan={9}>
                          <TableContainer
                            sx={{
                              mt: 2,
                              width: "100%",
                              overflowX: { xs: "scroll", sm: "auto" },
                            }}
                          >
                            <Table size="small" aria-label="suborders">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Suborder ID</TableCell>
                                  <TableCell>Client Name</TableCell>
                                  <TableCell>Volume</TableCell>
                                  <TableCell>Destination</TableCell>
                                  <TableCell>Scheduled Delivery Date</TableCell>
                                  <TableCell>Delivered At</TableCell>
                                  <TableCell align="right">Actions</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.assignedClientSubOrders?.map(
                                  (sub) => (
                                    <TableRow
                                      key={"client-assignment-" + sub.index}
                                      sx={{ ...nestedTableStyle }}
                                      selected={
                                        this.state.selectedOrder.index ===
                                        sub.index
                                      }
                                    >
                                      <TableCell>{sub.suborder_id}</TableCell>
                                      <TableCell>{sub.client_name}</TableCell>
                                      <TableCell>{sub.volume}</TableCell>
                                      <TableCell>
                                        {sub.delivery_location}
                                      </TableCell>
                                      <TableCell>
                                        {sub.scheduled_delivery_date
                                          ? moment(
                                              sub.scheduled_delivery_date,
                                            ).format("YYYY/MM/DD - HH:mm:ss")
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        {sub.delivered_at
                                          ? moment(sub.delivered_at).format(
                                              "YYYY/MM/DD - HH:mm:ss",
                                            )
                                          : ""}
                                      </TableCell>
                                      <TableCell align="right">
                                        {sub?.suborder_id === "DEPOT" &&
                                          !sub?.confirmed && (
                                            <Tooltip title="Confirm Delivery">
                                              <IconButton
                                                onClick={() =>
                                                  this.handleConfirmDepotDelivery(
                                                    sub,
                                                  )
                                                }
                                              >
                                                <WhereToVote color="success" />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </TableCell>
                      </TableRow>
                    )}
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )}

        {isCustoms && this.state.customsTab === 1 && (
          <TableContainer
            sx={{
              mt: 2,
              width: "100%",
              overflowX: { xs: "scroll", sm: "auto" },
            }}
          >
            <Table aria-label="outstanding documents table">
              <TableHead>
                <TableRow>
                  <TableCell>Suborder ID</TableCell>
                  <TableCell align="right">Supplier Name</TableCell>
                  <TableCell align="right">Logistics Company</TableCell>
                  <TableCell align="right">Product</TableCell>
                  <TableCell align="right">Volume</TableCell>
                  <TableCell align="right">Delivery Date</TableCell>
                  <TableCell align="right">Missing Documents</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {outstandingSuborders.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      All customs documents are uploaded.
                    </TableCell>
                  </TableRow>
                )}
                {outstandingSuborders.map((order) => {
                  const missingDocuments = this.getOutstandingDocuments(order);
                  return (
                  <TableRow
                    key={`outstanding-${order.suborder_id}`}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "&:hover": {
                        backgroundColor: "rgba(39,226,245,0.27)",
                      },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {order.suborder_id}
                    </TableCell>
                    <TableCell align="right">
                      {order.supplier || order.supplier_name}
                    </TableCell>
                    <TableCell align="right">
                      {order.logistic || "-"}
                    </TableCell>
                    <TableCell align="right">
                      {order.product || order.fuel_type}
                    </TableCell>
                    <TableCell align="right">
                      {fNumber(order.volume)}
                    </TableCell>
                    <TableCell align="right">
                      {moment(
                        order.scheduled_delivery_date ||
                          order.delivery_scheduled_datetime,
                      ).format(
                        "YYYY/MM/DD - HH:mm:ss",
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          useFlexGap
                          flexWrap="wrap"
                          justifyContent="flex-end"
                        >
                          {missingDocuments.map((doc) => (
                            <Box
                              key={`missing-${order.suborder_id}-${doc.key}`}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                backgroundColor: "#FFF5F5",
                                border: "1px solid #F5C6C6",
                                borderRadius: "12px",
                                padding: "6px 10px",
                                minHeight: "36px",
                              }}
                            >
                              <FolderOff color={palette.error.main} />
                              <Box>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {doc.label}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: "text.secondary" }}
                                >
                                  Outstanding
                                </Typography>
                              </Box>
                              {doc.uploadType && (
                                <Tooltip title={`Upload ${doc.label}`}>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      this.handleCustomsDocumentUpload(
                                        order,
                                        doc.uploadType,
                                      )
                                    }
                                  >
                                    <FileArrowUpFill
                                      color={palette.info.main}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          ))}
                        </Stack>
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Tooltip title="View Summary">
                        <IconButton
                          onClick={() => this.handleOutstandingSummary(order)}
                        >
                          <WorkHistory color={palette.warning.main} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="View Logistics">
                        <IconButton
                          onClick={() => this.handleOutstandingLogistics(order)}
                        >
                          <LocalShipping color={palette.info.main} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <CustomTablePagination
          rowsPerPage={this.state.records}
          recordsList={this.state.recordsList}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
          handleNextPage={this.nextPage.bind(this)}
          currentPage={this.state.page}
          totalPages={this.state.totalPages}
        />

        <CustomModal
          openModal={openDocumentModal}
          handleCloseModal={() => this.handleDocumentUploadModal(null, false)}
          modalTitle={`Suborder ${this.state.selectedOrder?.suborder_id || ""} Document`}
          modalIcon="document"
          modalStyle={modalStyle}
        >
          {!isFilePreview && (
            <>
              <Box sx={{ my: 2 }}>
                <FileDragzone
                  acceptedTypes={{
                    "application/pdf": [".pdf"],
                  }}
                  fileObjects={fileObjects}
                  handleFileObjects={this.handleFileObjects}
                  filesLimit={1}
                  maxFileSizeMB={MAX_FILE_SIZE_MB}
                />
              </Box>

              <FormItemlGrid label={"Document Type"}>
                <FormControl fullWidth sx={{ backgroundColor: "whitesmoke" }}>
                  <CustomSelect
                    // label={"Document Type"}
                    labelId="document-select-label"
                    value={this.state.upload.value}
                    onChange={(e) => {
                      this.setState({
                        upload: {
                          ...this.state.upload,
                          value: e.target.value,
                          error: false,
                        },
                        isReleaseForm: e.target.value === "RELEASE FORM",
                      });
                    }}
                    required={this.state.upload.required}
                    error={this.state.upload.error}
                    helperText={
                      this.state.upload.error && this.state.upload.errorMessage
                    }
                  >
                    <MenuItem value="" disabled>
                      <em>Select Document Type</em>
                    </MenuItem>
                    {documentTypes?.map((doc) => (
                      <MenuItem key={`document-${doc.key}`} value={doc.key}>
                        {doc.value}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </FormControl>
              </FormItemlGrid>

              <Grid container alignItems={"center"} sx={{ mt: 2 }}>
                {this.state.isReleaseForm && (
                  <Grid
                    item
                    size={{ xs: 10 }}
                    sx={{ display: "flex", justifyContent: "left" }}
                  >
                    <FormControl component="fieldset">
                      <FormControlLabel
                        sx={{ margin: 0 }}
                        control={
                          <Switch
                            checked={this.state.skipReleaseFormUpload}
                            onChange={(e) =>
                              this.setState({
                                skipReleaseFormUpload: e.target.checked,
                              })
                            }
                            name="skipReleaseFormUpload"
                          />
                        }
                        label="Skip Release Form Upload?"
                        labelPlacement="start"
                      />
                    </FormControl>
                  </Grid>
                )}

                <Grid
                  item
                  size={{ xs: this.state.isReleaseForm ? 2 : 12 }}
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "right",
                  }}
                >
                  <Button
                    variant="contained"
                    color="inherit"
                    onClick={() => this.handleDocumentUploadModal(null, false)}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    sx={{ ml: 2 }}
                    variant="contained"
                    onClick={() =>
                      this.state.skipReleaseFormUpload
                        ? this.handleDocumentSubmit()
                        : this.handleDocumentPreview()
                    }
                  >
                    {this.state.skipReleaseFormUpload ? `Finish` : `Continue `}
                  </LoadingButton>
                </Grid>
              </Grid>
            </>
          )}

          {isFilePreview && (
            <>
              <Box sx={{ mt: 2 }}>
                <Grid
                  item
                  size={{ xs: 12 }}
                  sx={{ my: "auto", display: "flex", justifyContent: "center" }}
                >
                  <CustomPdfViewer fileUrl={filePreviewUrl || null} />
                </Grid>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "right", mt: 2 }}>
                <Button
                  variant="contained"
                  color="inherit"
                  onClick={() => this.handleDocumentUploadModal(null, false)}
                >
                  Cancel
                </Button>
                <LoadingButton
                  sx={{ ml: 2 }}
                  variant="contained"
                  loading={this.state.submitted}
                  onClick={() => this.handleDocumentSubmit()}
                >
                  Finish
                </LoadingButton>
              </Box>
            </>
          )}
        </CustomModal>

        <CustomModal
          openModal={this.state.openSubDocumentModal}
          handleCloseModal={() => this.handleViewSubOrderDocument(null)}
          modalTitle={`${selectedSubDocument?.document_type} document: ${selectedSubDocument?.document_file_name}`}
          modalIcon="document"
          modalStyle={{ ...filePreviewStyle }}
        >
          <>
            <Box sx={{ mt: 2 }}>
              <Grid
                item
                size={{ xs: 12 }}
                sx={{ my: "auto", display: "flex", justifyContent: "center" }}
              >
                <CustomPdfViewer
                  fileUrl={selectedSubDocument?.document_url || null}
                />
              </Grid>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "right", mt: 2 }}>
              <Button
                variant="contained"
                color="inherit"
                onClick={() => this.handleViewSubOrderDocument(null)}
              >
                Cancel
              </Button>
            </Box>
          </>
        </CustomModal>

        <CustomModal
          openModal={this.state.openOutstandingSummary}
          handleCloseModal={() => this.handleOutstandingSummary(null)}
          modalTitle={`Suborder ${selectedOutstandingSuborder?.suborder_id || ""} Summary`}
          modalIcon="document"
        >
          <>
            <Box
              sx={{
                backgroundColor: "#FAFAFA",
                borderRadius: "12px",
                padding: 2,
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Timeline
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Stack spacing={2}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Created At
                  </Typography>
                  <Typography variant="body1">
                    {this.formatDateTime(selectedOutstandingSuborder?.created_at)}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Scheduled Delivery
                  </Typography>
                  <Typography variant="body1">
                    {this.formatDateTime(
                      selectedOutstandingSuborder?.scheduled_delivery_date,
                    )}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Transport Approved
                  </Typography>
                  <Typography variant="body1">
                    {this.formatDateTime(
                      selectedOutstandingSuborder?.transport_approved_at,
                    )}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Assigned At
                  </Typography>
                  <Typography variant="body1">
                    {this.formatDateTime(
                      selectedOutstandingSuborder?.assigned_at,
                    )}
                  </Typography>
                </Box>
              </Stack>
            </Box>

            <Box
              sx={{
                backgroundColor: "#F7FBFF",
                borderRadius: "12px",
                padding: 2,
                mt: 2,
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Ownership
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Typography variant="caption" color="text.secondary">
                Created By
              </Typography>
              <Typography variant="body1">
                {selectedOutstandingSuborder?.created_by || "-"}
              </Typography>
            </Box>
          </>
        </CustomModal>

        <CustomModal
          openModal={this.state.openOutstandingLogistics}
          handleCloseModal={() => this.handleOutstandingLogistics(null)}
          modalTitle={`Suborder ${selectedOutstandingSuborder?.suborder_id || ""} Logistics`}
          modalIcon="document"
        >
          <>
            <Box
              sx={{
                backgroundColor: "#FAFAFA",
                borderRadius: "12px",
                padding: 2,
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Driver Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Stack spacing={2}>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Driver
                  </Typography>
                  <Typography variant="body1">
                    {selectedOutstandingSuborder?.driver || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Vehicle
                  </Typography>
                  <Typography variant="body1">
                    {selectedOutstandingSuborder?.vehicle || "-"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Trailer
                  </Typography>
                  <Typography variant="body1">
                    {selectedOutstandingSuborder?.trailer || "-"}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </>
        </CustomModal>

        <OrderAllocationSummary
          orderData={this.state.selectedOrder}
          handleCloseModal={() => this.handleViewAllocationSummary(null)}
          openModal={this.state.viewAllocationSummary}
        />

        <OrderNominationSummary
          orderData={this.state.selectedOrder}
          handleCloseModal={() => this.handleViewNominationSummary(null)}
          openModal={this.state.viewNominationSummary}
        />

        <AssignEnrouteTruck
          subOrder={this.state.selectedOrder}
          clients={this.state.unassignedClientSubOrders}
          openModal={this.state.openTruckAssignment}
          handleCloseModal={() => this.handleAssignEnrouteTruck(null)}
          handleSubmitCallback={() => this.handleAssignEnrouteTruck(null, true)}
        />

        <OrderCollectionConfirmation
          openModal={this.state.viewConfirmCollection}
          orderData={this.state.selectedOrder}
          handleCloseModal={() => this.handleConfirmCollection(null)}
          handleSubmitCallback={() => {
            this.handleConfirmCollection(null);
            this.loadRefreshData();
          }}
        />

        <DepotDeliveryConfirmation
          openModal={this.state.viewConfirmDelivery}
          truckAssignment={this.state.selectedTruckAssignment}
          handleCloseModal={() => this.handleConfirmDepotDelivery(null)}
          handleSubmitCallback={() => {
            this.getAssignedClientSubOrders(
              this.state.selectedOrder.suborder_id,
            );
            this.handleConfirmDepotDelivery(null);
            this.loadRefreshData();
          }}
        />
      </Paper>
    );
  }
}

AllocatedOrders.propTypes = {
  filterString: PropTypes.string,
};
